import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { UserCheck, LogOut } from "lucide-react";

export default function MasqueradeBanner() {
  const { user, isMasquerading, stopMasquerade } = useAuth();
  const [busy, setBusy] = useState(false);

  if (!isMasquerading || !user) return null;

  const handleReturn = async () => {
    setBusy(true);
    try { await stopMasquerade(); } finally { setBusy(false); }
  };

  return (
    <div
      data-testid="masquerade-banner"
      className="sticky top-0 z-[60] w-full bg-amber-500 text-amber-950 border-b border-amber-600 shadow-sm"
    >
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-[13px] font-medium">
          <UserCheck className="w-4 h-4 shrink-0" />
          <span>
            You are signed in as <strong>{user.name || user.email}</strong>
            <span className="opacity-80"> ({user.email})</span>
            <span className="opacity-80"> — impersonating on behalf of </span>
            <strong>{user.impersonated_by}</strong>
          </span>
        </div>
        <button
          data-testid="masquerade-return-btn"
          onClick={handleReturn}
          disabled={busy}
          className="inline-flex items-center gap-1.5 rounded-md bg-amber-950 text-amber-50 px-3 py-1 text-[12px] font-semibold hover:bg-amber-900 disabled:opacity-60"
        >
          <LogOut className="w-3.5 h-3.5" />
          {busy ? "Returning…" : "Return to admin"}
        </button>
      </div>
    </div>
  );
}
